export default __webpack_public_path__ + "img/left-arrow.c3120a85.svg";